class ConsoleLocalStorageClass {
  setAccessToken(token) {
    localStorage.setItem("access_token", token);
  }
  getAccessToken() {
    return localStorage.getItem("access_token");
  }

  setRefreshToken(token) {
    localStorage.setItem("refresh_token", token);
  }
  getRefreshToken() {
    return localStorage.getItem("refresh_token");
  }

  setUser(user) {
    localStorage.setItem("user", JSON.stringify(user));
  }
  getUser() {
    try { return JSON.parse(localStorage.getItem("user")); }
    catch (e) { return null; }
  }

  setRememberMe(flag) {
    localStorage.setItem("remember_me", flag);
  }
  getRememberMe() {
    return localStorage.getItem("remember_me");
  }

  setOrganization(user) {
    localStorage.setItem("organization", JSON.stringify(user));
  }
  getOrganization() {
    try { return JSON.parse(localStorage.getItem("organization")); }
    catch (e) { return null; }
  }

  setFTU(status){
    localStorage.setItem("ftu", JSON.stringify(status));
  }

  getFTU(){
    try { return JSON.parse(localStorage.getItem("ftu")); }
    catch (e) { return null; }
  }

  //discord
  setDiscordInviteUrl(url){
    localStorage.setItem("discord_invite_url", JSON.stringify(url));
  }
  getDiscordInviteUrl(){
    try { return JSON.parse(localStorage.getItem("discord_invite_url")); }
    catch (e) { return null; }
  }

  setDiscordAccessUrl(url){
    localStorage.setItem("discord_access_url", JSON.stringify(url));
  }
  getDiscordAccessUrl(){
    try { return JSON.parse(localStorage.getItem("discord_access_url")); }
    catch (e) { return null; }
  }

  setDiscordJoined(flag){
    localStorage.setItem("discord_joined", flag);
  }
  getDiscordJoined(){
    try { return JSON.parse(localStorage.getItem("discord_joined")); }
    catch (e) { return null; }
  }

  setDiscordVerified(flag){
    localStorage.setItem("discord_verified", flag);
  }
  getDiscordVerified(){
    try { return JSON.parse(localStorage.getItem("discord_verified")); }
    catch (e) { return null; }
  }

  clearStorageExceptFTU(){
    localStorage.removeItem("access_token");
    localStorage.removeItem("organization");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("remember_me");
    localStorage.removeItem("user");
    localStorage.removeItem("discord_verified");
    localStorage.removeItem("discord_joined");
    localStorage.removeItem("discord_access_url");
    localStorage.removeItem("discord_invite_url");
    
  }

}
const ConsoleLocalStorage = new ConsoleLocalStorageClass();
export default ConsoleLocalStorage;
